


































// Vue
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'DatePicker'
})
export default class DatePicker extends Vue {
    @Prop() readonly label!: string
    @Prop({ default: false }) readonly required!: boolean
    @Prop({ default: false }) readonly disabled!: boolean
    @Prop({ default: false }) readonly hideHeader!: boolean
    @Prop({ default: '', required: true }) readonly id!: string | number
    @Prop({ default: '' }) readonly name!: string
    @Prop({ default: '' }) readonly className!: string
    @Prop({ default: '' }) readonly iconClass!: string
    @Prop({ default: '' }) readonly default!: string
    @Prop({ default: '' }) readonly msgError!: string
    @Prop({ default: null }) readonly hasError!: boolean|null
    @Prop({ default: () => ({ year: 'numeric', month: 'numeric', day: 'numeric' }) }) dateFormatOptions!: { year: string; month: string; day: string }

	value = this.default
    locale = 'es-ES'

    labels = {
          es: {
            labelPrevDecade: 'Década anterior',
            labelPrevYear: 'Año anterior',
            labelPrevMonth: 'El mes pasado',
            labelCurrentMonth: 'Mes Actual',
            labelNextMonth: 'Próximo Mes',
            labelNextYear: 'El próximo año',
            labelNextDecade: 'La próxima década',
            labelToday: 'Hoy dia',
            labelSelected: 'Fecha seleccionada',
            labelNoDateSelected: 'Sin fecha elegida',
            labelCalendar: 'Calendario',
            labelNav: 'Navegación de calendario',
            labelHelp: 'Utilice las teclas de flecha para navegar por el calendario'
          }
    }

    input () {
        this.$emit('change', this.value)
        this.$emit('input', this.value)
    }

    @Watch('default', { immediate: true, deep: true })
    changeOptions (newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.value = this.default
            this.input()
        }
    }
}
